import { useSelector } from 'react-redux';

import { SYSTEM_PROPERTIES } from 'constants/properties';
import useCompanyId from 'hooks/useCompanyId';

// Specific module, not the `store/companies/selectors` barrel — the barrel transitively requires
// the ColumnFilterElement component graph (via leadSources.selectors -> constants/options), which
// breaks consumers' lean test environments and mirrors the circular-require hazard documented in
// useResolvedDisclosuresSendAction.
import { selectCompanyPropertyByPropertyName } from 'store/companies/selectors/properties.selectors';

// Per-tenant kill switch for the Prepare Disclosures wizard (DEV-4624's feature-flag AC).
// Opt-out: absent/false keeps the wizard entry points wherever the Initial Disclosures send
// action resolves; 'true' hides them without touching the underlying loan actions. Company
// properties are already loaded by LoanApplicationContent, so this adds no fetch.
const useIsPrepareDisclosuresWizardDisabled = () => {
  const companyId = useCompanyId();

  const wizardDisabledProperty = useSelector(
    selectCompanyPropertyByPropertyName(
      companyId,
      SYSTEM_PROPERTIES.PREPARE_DISCLOSURES_WIZARD_DISABLED,
    ),
  );

  return wizardDisabledProperty?.propertyValue === 'true';
};

export default useIsPrepareDisclosuresWizardDisabled;
